export default class PinitComponent {
  public static pinit(image: HTMLImageElement | HTMLElement, options?: any) {
    const defaults = {
      button: "/images/pinit_icon.png",
      class: "pinit--wrap",
      ignore: ".pinit-ignore",
      minHeight: 200,
      minWidth: 200,
      selector: "img",
    };

    const settings = Object.assign({}, defaults, options);
    let images: HTMLImageElement | NodeList =
      image instanceof HTMLImageElement ? image : image.querySelectorAll(settings.selector);

    const ios = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
    const isAbsoluteURL = new RegExp("^(?:[a-z]+:)?//", "i");

    const isSingleImage = images instanceof HTMLImageElement;
    images = isSingleImage ? images : Array.prototype.slice.call(images).filter((img) => !img.matches(settings.ignore));

    function pinito(img) {
      if (img.dataset.pinit !== undefined || img.height < settings.minHeight || img.width < settings.minWidth) {
        return;
      }

      let imgURL = img.dataset.pinitImage || img.getAttribute("src");
      const hOne = document.querySelector("h1");
      const title = img.dataset.pinitTitle || (hOne !== null ? hOne.innerText : "");
      let pinButton;

      const wrap = document.createElement("div");
      wrap.setAttribute("class", settings.class);
      wrap.style.position = "relative";
      wrap.style.display = "inline-block";
      wrap.className += ` ${img.className}`;
      wrap.classList.remove('lazy-hidden');
      wrap.classList.remove('lazy');

      imgURL = isAbsoluteURL.test(imgURL)
        ? imgURL
        : window.location.protocol + "//" + window.location.hostname + imgURL;

      let shareURL = "https://www.pinterest.com/pin/create/button/?url=" + encodeURIComponent(document.URL);
      shareURL += "&media=" + encodeURIComponent(imgURL);
      shareURL += "&description=" + encodeURIComponent(title);

      if (ios) {
        pinButton = document.createElement("a");
        pinButton.setAttribute("class", "pin-it");
        pinButton.setAttribute("href", shareURL);
        pinButton.setAttribute("target", "_blank");
      } else {
        pinButton = document.createElement("span");
        pinButton.setAttribute("class", "pin-it");
        pinButton.addEventListener("click", (e) => {
          window.open(shareURL, "_blank", "width=700, height=300");
          const heins = document.querySelector("h1");

          // noinspection TsLint
          if (window.hasOwnProperty("ga") && typeof window["ga"] === "function") {
            // noinspection TsLint
            window["ga"].call(
              "send",
              "event",
              "Content",
              "Share to Pinterest",
              heins !== null ? heins.innerText : "Content of Connox design",
            );
          }

          e.preventDefault();
        });
      }

      pinButton.style.opacity = "0";

      const pinImg = document.createElement("img");
      pinImg.setAttribute("src", settings.button);

      const imgClone = img.cloneNode();
      imgClone.className = "";
      imgClone.dataset.pinit = true;

      pinButton.appendChild(pinImg);
      wrap.appendChild(pinButton);
      wrap.appendChild(imgClone);

      const parent = img.parentElement;
      parent.removeChild(img);
      parent.appendChild(wrap);

      pinButton.style.opacity = "";
    }

    function pinitAfterComplete(imago) {
      if (imago.complete && imago.src !== window.location.href) {
        pinito(imago);
      } else if (imago.classList.contains('lazy')){
        imago.addEventListener("load", (evt) => pinito(evt.target));
      }
    }

    if (images instanceof HTMLImageElement) {
      pinitAfterComplete(images);
    } else {
      images.forEach((imag) => {
        pinitAfterComplete(imag);
      });
    }
  }
}
